import React from 'react';
import { useContext } from 'react';
import { DataContext } from '../../Layouts';
import FeatureWork from './feature-work/FeatureWork';


const FeaturedWorks = () => {
    const {allWorks} = useContext(DataContext);
    const featuredWorks = allWorks.filter(work => 'featured' in work);

    return (
        <div className="my-5">
            {         
                featuredWorks.map((fw,index) =>  <FeatureWork key={index} no={index+1} work={fw}/> )
            } 
        </div>
    );
};

export default FeaturedWorks;